import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-176" data-mp="21yd8ya0c84tx">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-electric/30 border-l-4 border-l-electric bg-panel p-4 pr-10 text-white shadow-2xl shadow-black/50" aria-live="polite" data-id="element-177" data-mp="1wyh3e6bzs5c9">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-ink transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Dismiss notice" data-id="element-178" data-mp="1sh7l4tq6py3l">
            <XIcon className="h-4 w-4" data-id="element-179" data-mp="1ng1rmtopa6t0" />
          </button>
          <div className="flex gap-3" data-id="element-180" data-mp="1ninyer3roia6">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-181" data-mp="19p50l7af9xo2" />
            <div data-id="element-182" data-mp="1egmytnl29k5c">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-electric" data-id="element-183" data-mp="1eh6hx7mg6eky">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-ink" data-id="element-184" data-mp="zstnwg6x75t3">
                Once your purchase is complete you receive the
                <br data-id="element-185" data-mp="14nz4r0lgtuab" />
                <span className="font-bold text-white" data-id="element-186" data-mp="qq0tw56csfzk">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-ink" data-id="element-187" data-mp="vpdoxd7dotd8">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}